/*
vertical-menu.controller.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/

define('modules/shell/controllers/vertical-menu.controller',[
    'lodash',
    '../module',
    'system-config',
    '../services/application.service',
    '../services/user.service'
], function (_, module, systemConfig) {
    'use strict';

    module.controller('VerticalMenuController', [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        '$window',
        '$transitions',
        'ShellUserService',
        'uaf.appshell.AppConfig',
        function ($scope, $rootScope, $state, $http, $window, $transitions, UserService, appConfig) {

            $scope.menuItems = [];

            $scope.hideNavigation = false;

            $scope.selectedMenuItem = null;

            $scope.isCollapsed = false;

            $scope.windowSize = 'MD';

            $scope.onMenuItemClick = function (item, source) {
                if (source.navigate) {
                    if (source.navigationUrl) {
                        $window.location.href = source.navigationUrl;
                    } else {
                        if (source.reload !== undefined && source.reload) {
                            $state.go(source.view, source.params || {}, { reload: true });
                        } else {
                            $state.go(source.view, source.params || {});
                        }
                        $scope.selectedMenuItem = source;
                        item.open = false;
                        item.collapsed = false;

                        if ($scope.windowSize !== 'MD') {
                            $scope.isCollapsed = false;
                        }
                    }
                } else {
                    source.collapsed = !source.collapsed;
                }
            };

            var closeAllMenuItems = function (menuItems) {
                menuItems.forEach(function (item) {
                    item.open = false;
                    item.menuItems && closeAllMenuItems(item.menuItems);
                });
            };

            $scope.onOutsideClick = function () {
                closeAllMenuItems($scope.menuItems);
            };

            $scope.onWindowSizeChange = function (size) {
                if ($scope.windowSize !== size) {
                    $scope.isCollapsed = false;
                    $scope.windowSize = size;
                }
            };

            /*
            * Function to toggle left navigation menu on hamburger icon click
            */
            $scope.toggleLeftMenu = function () {
                $scope.isCollapsed = !$scope.isCollapsed;
                $scope.menuItems.forEach(function (menu) {
                    if (!menu.navigate && menu.active) {
                        menu.collapsed = false;
                        menu.open = false;
                    }
                });
            };

            // TODO - temporary solution until integrate these modules back with app descriptor
            var noMenuStates = ['login', 'logout', 'ssoSignInRedirect', 'sso-login', 'virtualViewer.viewer', 'zfpViewer.viewer'];
            $scope.showMenu = function () {
                return !!$state.current.name && !(noMenuStates.filter(function (s) { return s === $state.current.name; })[0]);
            };

            $scope.checkHiddenLeftNav = function () {
                var activeModule = appConfig.getActiveModule();

                $scope.hideNavigation = !!(activeModule && activeModule.hideNavigation) || !$scope.showMenu();
            };

            $scope.selectMenuByStateName = function (menuItem, stateName, toParams) {
                menuItem.active = stateName.indexOf(menuItem.view) === 0;
                if (!menuItem.navigate) {
                    menuItem.collapsed = !menuItem.active;
                }

                if (menuItem.params) {
                    menuItem.active = menuItem.active && _.matches(menuItem.params)(toParams);
                }

                _.forEach(menuItem.menuItems, function (item) {
                    $scope.selectMenuByStateName(item, stateName, toParams);
                });
            };

            $transitions.onSuccess({}, function (transition) {
                $scope.checkHiddenLeftNav();
                $scope.selectMenuByStateName($scope, transition.targetState().name(), transition.targetState().params());
            });

            var getUserItems = function (items) {
                var userItems = [];
                items = items || [];

                items.forEach(function (item) {
                    if (!item.roles || !item.roles.length || (UserService.doesUserHaveAppAccess(item.applicationAccess) && UserService.doesUserHaveAnyRoles(item.roles))) {
                        userItems.push(item);

                        if (item.menuItems && item.menuItems.length) {
                            item.menuItems = getUserItems(item.menuItems);
                        }
                    }
                });

                return userItems;
            };

            var init = function () {
                $rootScope.dataLoading('verticalMenu');
                UserService.getC360UsersData().then(function () {
                    UserService.getUserData().then(function () {
                        return $http.get(systemConfig.verticalMenuData);
                    }).then(function (response) {
                        $scope.menuItems = getUserItems(response.data.menuItems);
                        $scope.selectMenuByStateName($scope, $state.current.name);
                    }).finally(function () {
                        $rootScope.dataLoaded('verticalMenu');
                    });
                });
            };

            init();
        }]
    );
});
